import React from 'react';

import { Stack, Tooltip } from '@gogame/components';

export default ({ className, icon, label, color }) => {
  return (
    <Tooltip title={label} wrapper={true}>
      <Stack className={className} direction={'row'} alignItems={'center'}>
        {React.cloneElement(icon, {
          ...(color ? { color } : null),
          sx: {
            fontSize: 16,
          },
        })}
      </Stack>
    </Tooltip>
  );
};
